import { render, staticRenderFns } from "./highway.vue?vue&type=template&id=2b4f6faa&scoped=true&"
import script from "./highway.vue?vue&type=script&lang=js&"
export * from "./highway.vue?vue&type=script&lang=js&"
import style0 from "./highway.vue?vue&type=style&index=0&id=2b4f6faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f6faa",
  null
  
)

export default component.exports